{
  "name": "m3-free",
  "seed": 1,
  "track": "ring",
  "fixedDtMs": 16.666666666666668,
  "cars": [{ "id": "player", "spawn": { "x": 860, "y": 360, "angle": 1.5707963267948966 }, "ai": null }],
  "inputs": [],
  "captures": []
}
